// Lightweight analytics wrapper — GA4 + Meta Pixel + PostHog
// Fires only when the corresponding env var is set

const GA_ID = process.env.REACT_APP_GA4_ID || "";
const META_ID = process.env.REACT_APP_META_PIXEL_ID || "";

let initialized = false;

export function initAnalytics() {
  if (initialized || typeof window === "undefined") return;
  initialized = true;

  // Google Analytics 4
  if (GA_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID, { send_page_view: true });
  }

  // Meta Pixel
  if (META_ID) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", META_ID);
    window.fbq("track", "PageView");
  }
}

/**
 * Track a custom event across all analytics providers.
 * name: snake_case event name
 * params: optional object with additional properties
 */
export function track(name, params = {}) {
  try {
    if (window.gtag) window.gtag("event", name, params);
    if (window.fbq) window.fbq("trackCustom", name, params);
    if (window.posthog) window.posthog.capture(name, params);
  } catch {
    /* swallow */
  }
}

export function trackPageView(path) {
  try {
    if (window.gtag && GA_ID) {
      window.gtag("event", "page_view", { page_path: path });
    }
    if (window.fbq) window.fbq("track", "PageView");
    if (window.posthog) window.posthog.capture("$pageview", { $current_url: path });
  } catch {
    /* swallow */
  }
}
